// Module
var code = "<svg viewBox=\"0 0 7 8\" xmlns=\"http://www.w3.org/2000/svg\" width=\"7\" height=\"8\" stroke=\"none\"><path d=\"M1.472.139l5.05 3.014a.99.99 0 010 1.694l-5.05 3.014C.822 8.25 0 7.776 0 7.013V.987C0 .224.822-.25 1.472.139z\" fill-rule=\"evenodd\"/></svg> ";
// Exports
module.exports = code;